export default __webpack_public_path__ + "static/media/icon-visibility-off-color-gray.9bcb64c1.svg";